<div class="modal fade {{alertDialogState? 'show' : ''}}" id="alert-dialog-static-backdrop" data-bs-backdrop="static"
  data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="false">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body bg-white">
        <section class="confirm-dialog" fxLayout="column">
          <h4 mat-dialog-title>{{(args && args.title)? args?.title : "Attention!"}}</h4>
          <mat-dialog-content>
            <p>{{(args && args.message)? args?.message : "Are you sure you want to continue with this action?."}}</p>
          </mat-dialog-content>
          <mat-dialog-actions class="d-flex justify-content-end align-items-center">
            <button mat-raised-button color="primary" class="me-2" (click)="okay($event)"
              [mat-dialog-close]="true">{{args?.okayLabel || 'Okay'}}</button>
          </mat-dialog-actions>
        </section>
      </div>
    </div>
  </div>
</div>